import { CaregiverCertification } from "../messages";

export function getIsRN(certifications: CaregiverCertification[]) {
  return certifications.includes(CaregiverCertification.wrap("RN"));
}
